import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';
import { EnvironementService } from '../../services/environement.service';

@Component({
  selector: 'lib-pegase-chip-environement',
  standalone: true,
  imports: [CommonModule, MatChipsModule],
  templateUrl: './chip-environement.component.html',
  styleUrls: ['./chip-environement.component.scss']
})
export class ChipEnvironementComponent {

  private environementService = inject(EnvironementService);

  @Input() compact = false;

  get env(): string {
    return this.environementService.env;
  }

  get displayEnv(): string {
    return this.compact ? this.env.substring(0, 4).toUpperCase() : this.env;
  }

  getEnvClass(): string {
    return this.environementService.getEnvClass();
  }

  getEnvChipBaseClass(): string {
    return this.environementService.getEnvChipBaseClass();
  }

  isValidEnv(): boolean {
    return this.environementService.isValidEnv();
  }
}
